// To do

import React from 'react';
import styled from 'styled-components';
import PurpleSlashBG from '@images/sub-industry-slash.png';

const StyledLayout = styled.div`
  position: absolute;
  top: 0;
  left: 50%;
  height: 100%;
  width: 50%;
`;

const SlashEl = styled.div`
  width: 100%;
  height: 100%;
  z-index: 0;
  background-image: url(${props => props.bg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position-x: left;
  background-position-y: bottom;
`;

const IndustrySlash = ({ ...rest }) => {
  return (
    <StyledLayout {...rest}>
      <SlashEl bg={PurpleSlashBG}></SlashEl>
    </StyledLayout>
  );
};

export default IndustrySlash;
